import * as React from 'react'
import type { SVGProps } from 'react'
function SvgSterblichkeitFrauen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 93 93"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <path d="M66,70.6h-18v-17.2c6.6-.4,12.7-3.1,17.4-7.8,5.1-5.1,7.8-11.8,7.8-18.9s-2.8-13.9-7.8-18.9C60.3,2.8,53.7,0,46.5,0s-13.8,2.8-18.9,7.8c-5,5.1-7.8,11.8-7.8,18.9s2.8,13.9,7.8,18.9c4.7,4.7,10.8,7.4,17.4,7.8v17.2h-17.9c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h17.9v17.9c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5v-17.9h17.9c.8,0,1.5-.7,1.5-1.5s-.6-1.5-1.4-1.5ZM22.8,26.7c0-6.3,2.5-12.3,7-16.8s10.4-7,16.8-7,12.2,2.6,16.7,7.1,7,10.4,7,16.8-2.5,12.3-7,16.8-10.4,7-16.8,7-12.3-2.6-16.7-7.1-7-10.4-7-16.8Z" />
    </svg>
  )
}
export default SvgSterblichkeitFrauen
